<div class="bg-soft-white zn-border-radius p-1 mb-3">
  <div class="zn-row zn-text-size-100 zn-text-color-subdued">
    <div class="zn-col-auto pe-0">
      <zenith-icon [attr.icon-name]="znIconName" class="zn-text-size-200"></zenith-icon>
    </div>
    <div class="zn-col">{{ label }}</div>
  </div>
</div>
